import React from 'react';
import StartNow from '../../../Common-components/start-now/StartNow';
import "./Solutions.css";
import background from '../../Assets/background_images/background2.png';

const WorkStylePerformance = () => {
    return (
        <div>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
        <img className='image' src={background} alt='hiring' />
        <div className='heading'> Workstyle & Performance Profile </div>
        </div>
 
     <div> 
       <h1 className='title'>WHAT IS THE WPP ?</h1> 
       <p className='paragraph'> You can locate the ideal candidates faster and more efficiently with the Workstyle & Performance Profile recruiting evaluation tool. A substantial majority of employers believe that poor on-the-job productivity is due to a lack of "fit" rather than a lack of abilities and expertise. Employees are the key source of competitive advantage, and more firms are scrambling to hire exceptional individuals before their rivals. </p>
       <p className='paragraph'> Identifying and keeping top talent is more than simply finding the right individual with the relevant capabilities; it also entails determining the proper "match" and delivering the essential training. The Workstyle & Performance Profile (WPP), a personality test for recruitment and mentoring, predicts potential candidates' on-the-job performance, allowing you to make more informed hiring decisions.</p>
        <ul className='outer-list'>
            <li>Actionable suggestions on how to capitalize on the candidate's organic workstyle</li>
            <li>Mentoring and Development Opportunities</li>
            <li>Considerations for Job Fit</li>
            <li>Points for Management</li>
            <li>Recommended Interview Questionnaire</li>
        </ul>
     </div> 
     <hr />

     <div>
     <h1 className='title'> BENEFITS OF USING THE WPP </h1>
     <p className='paragraph'> When using hiring assessment tools companies have achieved: </p>
     <ul className='outer-list'>
         <li>Turnover Reduction of about  50% (Retail Employers)</li>
         <li>Production advancement and improvement of about 97% (Insurance Claims Examiners)</li>
         <li>Cost-per-Claim decrement of about 57%. (Healthcare Employer)</li>
         <li>Annual Sales per Rep flourishment (Banking Employer)</li>
     </ul>
     <p className='paragraph'> The Workstyle & Performance Profile recruiting evaluation tool is based on the Five Factor Model (FFM), but with the inclusion of Leadership Orientation and Achievement Orientation. </p>
     </div>
     <hr />

     <div>
     <h1 className='title'> WHY IS THE WPP DIFFERENT? </h1>
     <p className='paragraph'>Managers and recruiters all over the world use the WPP to place the right people in the right jobs. Their businesses are achieving unprecedented levels of productivity and job satisfaction. </p>
     <p className='paragraph'>View the 7 WPP aspects (non-dominant vs. dominant, satisfied vs. achievement-focused, reactive vs. calm, reserved vs. extroverted, direct vs. empathic, spontaneous vs. regulated, conventional vs. open-minded) at a glance, along with descriptions of various reactions. </p>
     </div>

     <div style={{textAlign:'center'}}>
       <StartNow/>
     </div>
     </div>
    )
}
 
export default WorkStylePerformance;